import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import { EditFnaStepComponent } from '../../editFnaPage/types';
import { JSX } from 'react';
import { validationsErrorMessages } from '../../../common/lib/validations';
import AsyncFormSelect from '../../../common/components/form/asyncFormSelect';
import NumberTextField from '../../../common/components/form/numberTextField';
/**
 * Step with FNA's buy and sell valuation form
 */
const ValuationStep: EditFnaStepComponent = ({ control }) => {
  return (
    <Box className="grid gap-8 md:grid-cols-2">
      <Controller
        control={control}
        rules={{
          required: { value: true, message: validationsErrorMessages.required },
          min: { value: 1, message: validationsErrorMessages.required },
        }}
        name="buyandsell.valuationMethodID"
        render={({ field, fieldState: { error } }): JSX.Element => (
          <AsyncFormSelect
            {...field}
            label="Valuation method"
            error={Boolean(error)}
            optionsEndpoint="/ValuationMethods"
            helperText={error?.message}
          />
        )}
      />
      <Controller
        name="buyandsell.valuationValue"
        control={control}
        rules={{
          required: { value: true, message: validationsErrorMessages.required },
          min: { value: 1, message: validationsErrorMessages.required },
        }}
        render={({ field, fieldState: { error } }): JSX.Element => (
          <NumberTextField
            {...field}
            prefix="R "
            label="Business valuation (own)"
            placeholder="e.g. 5000000"
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
      <Controller
        name="buyandsell.valuationBasisID"
        control={control}
        rules={{
          required: { value: true, message: validationsErrorMessages.required },
          min: { value: 1, message: validationsErrorMessages.required },
        }}
        render={({ field, fieldState: { error } }): JSX.Element => (
          <AsyncFormSelect
            {...field}
            label="Valuation basis"
            error={Boolean(error)}
            optionsEndpoint="/ValuationBasiss"
            helperText={error?.message}
          />
        )}
      />
    </Box>
  );
};

export default ValuationStep;
